export default __webpack_public_path__ + "36e22057a48ed9eea03b0f8b9ccf1be8.png";